module.exports = __webpack_public_path__ + "static/media/marker-warning.dfd4b2d7.png";